import React, { useEffect } from "react";
// import { createRoot } from 'react-dom/create';
import 'react-toastify/dist/ReactToastify.css';

import "./style/theme.scss";
import "./style/App.scss";
import "./style/scrollbar.css";

import { DefaultRouterProvider } from "./router/router";
import { ConfigProvider, theme, Button, message } from 'antd';
import { ToastContainer } from 'react-toastify';
import { MessageProvider } from "./components/providers/MessageContext";
import { useDispatch, useSelector } from 'react-redux';
import { logout } from './features/authSlice';
import { startTokenExpiryWatcher } from './utils/tokenExpiryWatcher';

function App() {
  const dispatch = useDispatch();
  const auth = useSelector((s) => s.auth);

  useEffect(() => {
    const getToken = () => localStorage.getItem('token') || (auth && auth.token);
    const stop = startTokenExpiryWatcher(getToken, () => dispatch(logout()), 5000);
    return () => stop && stop();
  }, [dispatch, auth]);

  return (
    <React.Fragment>
      <ConfigProvider
        theme={{
          token: {
            colorBgLayout: '#d4e6f5',
            colorPrimary: '#519BD6',

            colorText: '#000',
          }
        }}
      >
        <MessageProvider>
          <DefaultRouterProvider />
        </MessageProvider>
        {import.meta.env.DEV && (
          <div style={{ position: 'fixed', right: 16, bottom: 16, zIndex: 9999 }}>
            <Button
              onClick={() => {
                const ttlSeconds = 10;
                const header = { alg: 'none', typ: 'JWT' };
                const payload = { sub: 'dev-test', exp: Math.floor(Date.now() / 1000) + ttlSeconds };
                const b64 = (obj) => btoa(JSON.stringify(obj)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
                const token = `${b64(header)}.${b64(payload)}.`;
                localStorage.setItem('token', token);
                message.info(`Dev token set (expires in ${ttlSeconds}s).`);
              }}
            >
              Set Short-Lived Token (10s)
            </Button>
          </div>
        )}
      </ConfigProvider>
      <ToastContainer position="bottom-right" />
    </React.Fragment>
  );
}

export default App;
